import PropTypes from 'prop-types';

export const NODE_DATA_MODEL = {
  ACCESSTHROUGH: PropTypes.string,
  AUDIT_TRAIL: PropTypes.string,
  CERTIFIED: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  CERT_ACCOUNTKEY: PropTypes.string,
  CERT_ENTITLEMENT_VALUEKEY: PropTypes.string,
  CERT_ROLEKEY: PropTypes.string,
  CERT_USERKEY: PropTypes.string,
  COMMENTS: PropTypes.string,
  ENDPOINT: PropTypes.string,
  ENTITLEMENTTYPE: PropTypes.string,
  ENTITLEMENT_VALUE: PropTypes.string,
  Ent_DESCRIPTION: PropTypes.string,
  Ent_DISPLAYNAME: PropTypes.string,
  Ent_ENTITLEMENT_GLOSSARY: PropTypes.string,
  Ent_PRIVILIGED: PropTypes.string,
  LASTCERTIFIED: PropTypes.string,
  LASTCERTIFIEDCAMPAIGNNAME: PropTypes.string,
  LASTCERTIFIEDUSER: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  availableAction: PropTypes.shape({
    approve: PropTypes.string,
    conditionalCertifiy: PropTypes.string,
    consult: PropTypes.string,
    reassign: PropTypes.string,
    reject: PropTypes.string,
  }),
  enableAction: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string,
  isConsulted: PropTypes.bool,
  tracker: PropTypes.shape({
    actions: PropTypes.objectOf(
      PropTypes.shape({
        isSelected: PropTypes.bool,
        isLoading: PropTypes.bool,
      })
    ),
    id: PropTypes.string,
    isChecked: PropTypes.bool,
    isConnected: PropTypes.bool,
    level: PropTypes.number,
  }),
};

export const CONSULT_MODAL_DETAILS_MODEL = {
  isIncludeAssociatedEnt: PropTypes.bool.isRequired,
  isNoteRequired: PropTypes.bool.isRequired,
  noteText: PropTypes.string.isRequired,
  isIncludeAsscLabel: PropTypes.string.isRequired,
  lineItemKind: PropTypes.string.isRequired,
};

export const APPROVE_USER = {
  certKey: PropTypes.string,
  userKey: PropTypes.string,
  status: PropTypes.string,
};

export const VERIFY_PARENT_MAP_MODEL = PropTypes.shape({
  cert_userkey: PropTypes.string,
  cert_accountkey: PropTypes.string,
  status: PropTypes.string,
  type: PropTypes.string,
  username: PropTypes.string,
  userDisplayName: PropTypes.string,
  accountDisplayName: PropTypes.string,
  childName: PropTypes.string,
});

export const REASSIGN_CONFIG_MAP = {
  defaultReassignee: PropTypes.string,
  defaultReassigneeName: PropTypes.string,
  enableIndividualCommentsForAccountEntitlementRoles: PropTypes.arrayOf(
    PropTypes.string
  ),
  enableIndividualCommentsForUsers: PropTypes.arrayOf(PropTypes.string),
  enableReassignStep2: PropTypes.string,
  enableReassignUser: PropTypes.string,
  showReassignPopup: PropTypes.string,
};

export const COL_FILTERS_MODEL = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
        isChecked: PropTypes.bool.isRequired,
      })
    ),
  })
);

export const APPLIED_COL_FILTERS_MODEL = PropTypes.shape({
  USER: PropTypes.arrayOf(PropTypes.string),
  ACCOUNT: PropTypes.arrayOf(PropTypes.string),
  ROLE: PropTypes.arrayOf(PropTypes.string),
  ENTITLEMENT: PropTypes.arrayOf(PropTypes.string),
});
